import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="border-b border-background-200 bg-background-100">
      <ol className="mx-auto flex flex-wrap items-center gap-2 px-4 py-3 text-xs text-foreground-600 md:px-6 md:text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-900 font-medium" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}